/**
 * @param {string} country
 * @param {string|number} value
 * @returns {number|undefined}
 */
function getAgeFromSsn ({ country, value } = {}) {
  return require('./locales')?.[country]?.getAgeFromSsn(value)
}

module.exports = { getAgeFromSsn }
